import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-resume-content',
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './resume-content.component.html',
  styleUrl: './resume-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResumeContentComponent {}
